import styled from 'styled-components'

import { theme } from 'lib/styleUtils'

const Bundles = styled.div`
  border-top: ${theme('borderWidth')} solid ${theme('colors.light.subdued')};
`

export default Bundles
